import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';
import mutations from './mutations';
import actions from './actions';

Vue.config.devtools = true;
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    currentCart: null,
    mainProducts: [],
    addonProducts: [],
    cardProducts: [],
    feeProduct: null,
  },
  getters,
  mutations,
  actions,
});

export default store;
